import {FactoryID, RouteKey} from "../../model-factory/type-interface/ModelFactoryType";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import {PostType} from "../../manager/post/PostManager";
import {getManager} from "../../manager/Manager";
import RouteModel from "../../model-factory/basic/route/RouteModel";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {getModelFactory} from "../../model-factory/ModelFactory";

export class PostRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "post_route_id";

    postType:PostType = null!;
    choiceOrder = ["add", "list"];

    applyModelConditions()
    {
        super.applyModelConditions();

        this.postType = this.populateIDs.post_type!;
    }


    applyChoice(choice: RouteChoice)
    {
        const postConfig = this.postType ? (getManager().post.config[this.postType] ?? null) : null;
        let pageID:string|null = null;
        if(choice.id === "add"){
            pageID = postConfig?.addPageID ?? null;
        }
        choice.postDataChoice = pageID ? (getModelFactory().pageData.getPageDataModel().choices[pageID] ?? null) : null;
        if(choice.id === "list" && postConfig){
            choice.name = "Edit " + postConfig.plural;
        } else if(choice.postDataChoice){
            choice.name = choice.postDataChoice.name;
        }
        super.applyChoice(choice);
    }
}

export default class PostRouteFactory extends RouteFactory
{

    id: FactoryID = "post_route";

    constructor()
    {
        super();

        this.choices = {
            add: new RouteChoice({
                name: "Submit a Post"
            }),
            list: new RouteChoice({
                name: "Edit Posts",
                nextFactoryID: "post_list_route",
                publicID: "edit"
            })
        }
    }

    birth(id: FactoryID): PostRouteModel
    {
        return new PostRouteModel(id);
    }

    getDefaultModel(postType:PostType|null): PostRouteModel | null
    {

        postType = postType ?? "organisation";
        let routeIDs:IRouteIDs = {
            browse_route_id: "my_profile",
            my_profile_route_id: postType.toString()
        }
        return this.getDefaultModelWithRoute(routeIDs)! as PostRouteModel;
    }
}